export default __webpack_public_path__ + "5af0f87827ea0e312a7689c56227b8ef.svg";